import * as React from 'react';

import { Button } from '@cian/ui-kit';

import * as styles from './LoadMoreButton.css';

export interface ILoadMoreButtonProps {
  loading?: boolean;

  onClick(): void;
}

export const LoadMoreButton: React.FC<ILoadMoreButtonProps> = ({ loading, onClick }) => {
  return (
    <div className={styles['container']}>
      <Button loading={loading} onClick={onClick} theme={'fill_secondary'} size={'M'}>
        Ещё фотографии
      </Button>
    </div>
  );
};
